import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import { FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
  getApiAttractionSlots,
  getGermanStatesList,
} from '../../../services/accreditation-forms-service';
import store from '../../../store';
import { Tag, TagAppearance } from '@hid-galaxy-ui/galaxy-react';
import cx from 'classnames';
import styles from './InputTags.module.scss';
import { Loader, LoaderSizes } from '@hid-galaxy-ui/galaxy-react';

const useInputStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    maxWidth: theme.custom.inputs.maxWidth,
    marginBottom: theme.spacing(5),
    background: 'none'
  }
}));

// https://hidglobal.atlassian.net/browse/HIDEMS-3617 - Implementation of InputTags component
const InputTags = (props) => {
  const { tagsData, field, form, label, required, hint, ...restProps } = props;
  const { errors, touched } = form;
  const { t } = useTranslation();
  // const dispatch = useDispatch();
  const [tagOptions, setTagOptions] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);

  const { tenantId, token } = store.getState().formSession;

  useEffect(() => {
    getAttractionSlots();
  }, []);

  const classes = useInputStyles();

  const labelToDisplay = `${t(label)} ${required ? '*' : ':'}`;

  const shouldDisplayError = () => touched[field.name] && !!errors[field.name];

  const getAttractionSlots = async () => {
    try {
      const response = await getApiAttractionSlots(tenantId, token);
      if (response) {
        const tagsData = response.map((item) => ({
          key: item?.slotTime,
          label: item?.slotTime,
          availableSlots: item?.availableSlots,
        }));
        if (field.value) {
          const selectedTagItem = getSelectedTagByKey(tagsData);
          setSelectedTag(selectedTagItem);
        }

        setTagOptions(tagsData);
      }
    } catch (error) {
      setTagOptions([]);
    }
  };

  const handleTagClick = (selectedTag) => {
    const tagItem = tagOptions.find((item) => item?.key === selectedTag?.key);
    form.setFieldValue(field.name, tagItem.key);
    setSelectedTag(tagItem);
  };
  const getSelectedTagByKey = (tagsData) => {
    if (field?.value) {
      const op = tagsData.find((item) => item.key === field.value);
      return op;
    }
    return null;
  };

  const renderDisabledTags = (item, index) => {
    return (
      <div
        className={cx({ [styles.selectedTag]: item?.key === field?.value })}
        role="button"
        key={index}
      >
        <Tag disabled value={item.label} appearance={TagAppearance.Blue} />
      </div>
    );
  };

  const renderTags = (item, index) => {
    return (
      <div
        className={cx(
          { [styles.selectedTag]: item?.key === field?.value },
          'cursor-pointer',
        )}
        role="button"
        key={index}
        onClick={() => handleTagClick(item)}
      >
        <Tag value={item.label} appearance={TagAppearance.Blue} />
      </div>
    );
  };

  return (
    <div className={cx(classes.wrapper, 'hid-galaxy')}>
      <span style={{ 'font-size': 'small' }}>{labelToDisplay}</span>
      <div
        className={cx(
          styles.tagContainer,
          'hid-flex hid-flex-wrap hid-layout__mt-01',
        )}
      >
        {tagOptions ? (
          tagOptions?.map((item, index) => {
            return item.availableSlots === 0
              ? renderDisabledTags(item, index)
              : renderTags(item, index);
          })
        ) : (
          <Loader size={LoaderSizes.small} />
        )}
      </div>

      <FormHelperText
        variant="filled"
        required
        error={shouldDisplayError()}
        margin="dense"
      >
        {shouldDisplayError() ? errors[field.name] : hint}
      </FormHelperText>
     {tagOptions && <div className="hid-layout__mt-03">
        {t('AVAILABLE_SLOTS')}: {`${selectedTag?.availableSlots ?? ' ---'}`}
      </div>
}
    </div>
  );
};

export default InputTags;
